export function createDefaultSiteSetting() {
  return {
    profile: {
      title_color: '',
      desc_color: '',
      description: '',
      title_font: '',
      shape: '',
      description_style: {
        formats: [],
        alignment: 'center'
      }
    },
    page: {
      color: '',
      background: '',
      pattern: '',
    },
    wppOrEmail: {
      textForCard: '',
      background: {
        color1: '',
        color2: '',
        direction: ''
      },
      text: {
        color: '',
      }
    },
    style_socials: 1,
    backgrounds: {
      card1: { path: '', show: true },
      card2: { path: '', show: true },
      card3: { path: '', show: true },
      card4: { path: '', show: true },
      card5: { path: '', show: true },
      card6: { path: '', show: true },
      card7: { path: '', show: true },
      card8: { path: '', show: true },
      card9: { path: '', show: true },
    },
    galleries: {
      card1: { id: null, images: [] },
      card2: { id: null, images: [] },
      card3: { id: null, images: [] },
      card4: { id: null, images: [] },
      card5: { id: null, images: [] },
      card6: { id: null, images: [] },
      card7: { id: null, images: [] },
      card8: { id: null, images: [] },
      card9: { id: null, images: [] }
    },
    platforms: {
      card1: { name: '', nick: '', color: 1, url: '', url2: '', show: true, text: '', textColor: '', fonts: '', size: 'medium', position: 'left', logo_position: 'center' },
      card2: { name: '', nick: '', color: 1, url: '', url2: '', show: true, text: '', textColor: '', fonts: '', size: 'medium', position: 'left', logo_position: 'center' },
      card3: { name: '', nick: '', color: 1, url: '', url2: '', show: true, text: '', textColor: '', fonts: '', size: 'large', position: 'left', logo_position: 'center' },
      card4: { name: '', nick: '', color: 1, url: '', url2: '', show: true, text: '', textColor: '', fonts: '', size: 'medium', position: 'left', logo_position: 'center' },
      card5: { name: '', nick: '', color: 1, url: '', url2: '', show: true, text: '', textColor: '', fonts: '', size: 'large', position: 'right', logo_position: 'center' },
      card6: { name: '', nick: '', color: 1, url: '', url2: '', show: true, text: '', textColor: '', fonts: '', size: 'small', position: 'right', logo_position: 'center' },
      card7: { name: '', nick: '', color: 1, url: '', url2: '', show: true, text: '', textColor: '', fonts: '', size: 'medium', position: 'right', logo_position: 'center' },
      card8: { name: '', nick: '', color: 1, url: '', url2: '', show: true, text: '', textColor: '', fonts: '', size: 'medium', position: 'right', logo_position: 'center' },
      card9: { name: '', nick: '', color: 1, url: '', url2: '', show: true, text: '', textColor: '', fonts: '', size: 'small', position: 'right', logo_position: 'center' },
    },
    videos: {
      card1: { path: '', show: true },
      card2: { path: '', show: true },
      card3: { path: '', show: true },
      card4: { path: '', show: true },
      card5: { path: '', show: true },
      card6: { path: '', show: true },
      card7: { path: '', show: true },
      card8: { path: '', show: true },
      card9: { path: '', show: true },
    },
    newplatforms: [],
    schedules: {
      card1: { background: '', numSection: '', schedule: [] },
      card2: { background: '', numSection: '', schedule: [] },
      card3: { background: '', numSection: '', schedule: [] },
      card4: { background: '', numSection: '', schedule: [] },
      card5: { background: '', numSection: '', schedule: [] },
      card6: { background: '', numSection: '', schedule: [] },
      card7: { background: '', numSection: '', schedule: [] },
      card8: { background: '', numSection: '', schedule: [] },
      card9: { background: '', numSection: '', schedule: [] }
    },
  }
}
